/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$(document).ready(function() {
  $('.various').fancybox({
    youtube : {
      controls : 0,
      autoplay : 0,
      showinfo : 0
    },
    vimeo : {
      color : 'f00'
    }
  });

  //===================== Hide soldout button ===================//
  var id = setInterval(func, 100);

  function func() {
    if ($('#BIS_trigger').length > 0) {
      $('.ProductForm__AddToCart').hide();
      clearInterval(id);
    }
  }


  //   $('.product-image-with-text').on('click', '.variant-button', function(event){
  //   	event.preventDefault();
  //     $('.product-image-with-text .variant-button').removeClass('active');
  //     $(this).addClass('active');
  //     var variantId = $(this).data('variant-id');
  //     var url = '/cart/'+ variantId + ":1";
  //     $('.buyNowBtn').attr('href',url);
  //   })

  //   $('.product-image-with-text .variant-button').first().addClass('active').trigger('click');
  var isLandingPage = $('.landing-page-featured-product').length;
  if(isLandingPage){
    $('.landing-page-featured-product').on('click', '.variant-button', function(event){
      event.preventDefault();
      $('.landing-page-featured-product .variant-button').removeClass('active');
      $(this).addClass('active');
      var variantId = $(this).data('variant-id');
      var url = '/cart/'+ variantId + ":1";
      $('.buyNowBtn').attr('href',url);
    })

    $('.landing-page-featured-product .variant-button').first().addClass('active').trigger('click');

    $('.featured-product-banner').on('click', '.variant-button', function(event){
      event.preventDefault();
      $('.featured-product-banner .variant-button').removeClass('active');
      $(this).addClass('active');
      var variantId = $(this).data('variant-id');
      var url = '/cart/'+ variantId + ":1";
      $('.topBuyNowBtn').attr('href',url);
    })

    $('.featured-product-banner .variant-button').first().addClass('active').trigger('click');

  }

  if($("#shopify-section-light-of-life").length){
    $('.featured-product-banner').on('click', '.variant-button', function(event){
      event.preventDefault();
      $('.featured-product-banner .variant-button').removeClass('active');
      $(this).addClass('active');
      var variantId = $(this).data('variant-id');
      var url = '/cart/'+ variantId + ":1";
      $('.topBuyNowBtn').attr('href',url);
    })

    $('.featured-product-banner .variant-button').first().addClass('active').trigger('click');
  }


  $('.mobile-faqs-h-item').click(function(e){
    $(this).closest('.faqs-main-item-inner').toggleClass('active');
    $(this).closest('.faqs-main-item-inner').find('[data-accordion-group]').slideToggle();
    e.preventDefault();
  });
});

$(document).ready(function(){
  $('.product_large_img_list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-img-list-slider',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows:false,
          adaptiveHeight: true,
        }
      }
    ]
  });
  $('.product-img-list-slider').slick({
    dots:false,
    arrows: true,
    infinite:true,
    asNavFor: '.product_large_img_list',
    focusOnSelect: true,
    centerMode: false,
    slidesToShow:4,
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="https://cdn.shopify.com/s/files/1/0062/8637/7044/files/slider-left-icon.png?5237978386876805816" alt=""/></button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="https://cdn.shopify.com/s/files/1/0091/0707/9226/files/Layer_3_3.png?v=1582693337" alt=""/></button>',
    slidesToScroll:1,
    autoplay:false,
    autoplaySpeed:3000,

  });

    $('.product_large_img_list').on('afterChange', function(event, slick, currentSlide) {

      var Video = $('[data-slick-index="' + currentSlide + '"]' ).find('video');
       Video.length && Video.get(0).play();
  });

  //popup size chart
  $(function () {
    $('.pop-up-table').click(function () {
      $('.common-size-table, .template-product ').addClass('is-open');
      $('.shopify-section--header').addClass('hide-header');
      return false;
    });

    $('.close-btn').click(function () {
      $('.common-size-table').removeClass('is-open');
      $('.template-product').removeClass('is-open');
      $('.shopify-section--header').removeClass('hide-header');
    });
  });

  ///
  $('.hideSlink').click(function(){
    $('.swatch-element.hides').css('display','block');
    $('.hideSlink').hide();
  });
  if ($(window).width() < 768) {
    
    $('.faq-question').click(function(){
      $(this).find(".panel-content").toggleClass('faq-open');
      $(this).find(".faq-question-wrap").toggleClass('faq-sign');
    });
    
  }
  $('.item-container').click(function(){
    $(this).find(".item__content").toggleClass('open');
    $(this).find(".item-title").toggleClass('open-sign');
  });
  
  $('#shopify-section-custom-product .ProductListWrapper').slick({
    dots:false,
    arrows: false,
    infinite:true,
    slidesToShow:4,
    slidesToScroll:1,
    autoplay:true,
    autoplaySpeed:3000,
    responsive: [
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
      {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
     {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
    ]
  });
  if($('.stickyAddtoCart').length) {
    var adb = $('.template-product .product-page-desc #AddToCart').offset().top+70;
    $(window).scroll(function() {  
      var hh = $('#shopify-section-header').outerHeight();
      $(".stickyAddtoCart").css('top',hh+'px');
      var scroll = $(window).scrollTop();
      if (scroll >= adb) {
        $(".stickyAddtoCart").slideDown();
      } else {
        $(".stickyAddtoCart").slideUp();
      }
    });
  }

  $('.logo-slider').slick({
    dots:true,
    arrows: false,
    infinite:true,
    slidesToShow:4,
    slidesToScroll:1,
    autoplay:true,
    autoplaySpeed:3000,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});


// $(document).ready(function() {
//   $(".faq-question-wrap .panel-title").on("click", function() {
//     if ($(this).hasClass("active")) {
//       $(this).removeClass("active");
//       $(this)
//         .siblings(".panel-content")
//         .slideUp(200);
//       $(".faq-question-wrap .panel-title")
//         .removeClass("fa-minus")
//         .addClass("fa-plus");
//     } else {
//       $(".faq-question-wrap .panel-title")
//         .removeClass("fa-minus")
//         .addClass("fa-plus");
//       $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
//       $(".faq-question-wrap .panel-title").removeClass("active");
//       $(this).addClass("active");
//       $(".panel-content").slideUp(200);
//       $(this)
//         .siblings(".panel-content")
//         .slideDown(200);
//     }
//   });
// });
$('.swatch.clearfix.swatch-color input').click(function(){
  var val=$(this).val();
  $('.swatch.swatch-color').find('.header').children('span').text(val);
});

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// var button = document.getElementById('AddToCart');
// button.addEventListener(
//   'click', 
//   function() { 
//     fbq('track', 'AddToCart', {
//       content_name: 'Really Fast Running Shoes', 
//       content_category: 'Apparel & Accessories > Shoes',
//       content_ids: ['1234'],
//       content_type: 'product',
//       value: 4.99,
//       currency: 'USD' 
//     });          
//   },
//   false
// );

// $('body').on("click","#AddToCart.add_to_cart_button",function(e){
//   e.preventDefault();
//     $.ajax({
//       "type":"POST",
//       "dataType":"json",
//       "url":"/cart/add",
//       "data":$(this).closest('form').serialize(),
//       "async":false
//     }).done(function(data){
// //       fbq('track', 'AddToCart', {
// //         content_name: 'Really Fast Running Shoes', 
// //         content_category: 'Apparel & Accessories > Shoes',
// //         content_ids: ['1234'],
// //         content_type: 'product',
// //         value: 4.99,
// //         currency: 'USD' 
// //       });  
//       window.location='/cart';
//     });
// });